import type { ReactNode } from 'react';
import type { MemberWithUser } from '../../../shared/types';
import { Avatar, Badge } from '../ui';
import { formatRelative } from '../../lib/format';
import { cn } from '../../lib/utils';

export interface MemberRowProps {
  member: MemberWithUser;
  actions?: ReactNode;
  /** Replaces the plain role badge — a role <Select> when the viewer can edit it. */
  roleSlot?: ReactNode;
  className?: string;
}

/** One row of the Team table. WEB-4 owns role changes and removal. */
export function MemberRow({ member, actions, roleSlot, className }: MemberRowProps) {
  return (
    <div className={cn('flex items-center gap-3 border-b border-border px-4 py-3 last:border-0', className)}>
      <Avatar name={member.user.name} email={member.user.email} src={member.user.avatarUrl} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-fg">
          {member.user.name ?? member.user.email}
        </p>
        <p className="truncate text-xs text-subtle">{member.user.email}</p>
      </div>
      {roleSlot ?? (
        <Badge tone={member.role === 'owner' ? 'accent' : 'neutral'} className="capitalize">
          {member.role}
        </Badge>
      )}
      <span className="hidden text-xs text-subtle sm:inline">
        Joined {formatRelative(member.createdAt)}
      </span>
      {actions}
    </div>
  );
}
